import React from 'react';
import { Grid, Skeleton, Typography } from '@mui/material';
import FoodBaseButton from '../FoodBaseButton';
import FoodListItemRightIcon from '../FoodListItemRightIcon';
import FoodPriceListSkeleton from '../price/skeleton/FoodPriceListSkeleton';

interface FoodListItemSkeletonProps {
}

const FoodListItemSkeleton: React.FC<FoodListItemSkeletonProps> = ({ }) => {
    return (
        <FoodBaseButton food={{ isSelected: false }} onClick={() => { }}>
            <Grid padding={1.5} container direction="column" justifyContent="center" alignItems="flex-start">
                <Typography
                    fontWeight={600}
                    variant='subtitle2'
                    textAlign={"start"}>
                    <Skeleton width={70} />
                </Typography>
                <Typography
                    variant='subtitle2'
                    color={"text.secondary"}
                    textAlign={"start"}
                    overflow={"hidden"}
                    textOverflow={"ellipsis"}
                    width={"100%"}
                    noWrap
                    height={19.22}>
                    <Skeleton width={110} />
                </Typography>
                <FoodPriceListSkeleton />
                <FoodListItemRightIcon />
            </Grid>
        </FoodBaseButton>
    )
}

export default FoodListItemSkeleton;